<div class="modal-header">
  <h4 class="modal-title pull-left">
    <div [ngSwitch]="actionType">
     <span *ngSwitchCase="FileActionType.CREATE_FOLDER">Create Folder</span>
     <span *ngSwitchCase="FileActionType.RENAME">Rename</span>
     <span *ngSwitchCase="FileActionType.CHANGE_TYPE">Change Document Type</span>
    </div>
  </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">

  <div class="row" *ngIf="actionType == FileActionType.CREATE_FOLDER">
    <div class="col-sm-12">
      <div class="form-group" [ngClass]="{'has-warning': !validLength()}">
        <label class="rbv-label">Name</label>
        <input type="text" [(ngModel)]="folderName" placeholder="Enter Name" class="form-control rounded-0" [ngClass]="{'is-invalid': !validLength()}"
               name="folderName" maxlength="251" autocomplete="off" (keydown.enter)="onConfirm()" autofocus="autofocus"/>

        <span *ngIf="!validLength()" class="invalid-feedback">
            Maximum of 250 characters only
          </span>
      </div>

    </div>
  </div>

  <div class="row" *ngIf="actionType == FileActionType.RENAME">
    <div class="col-sm-12">
      <div class="form-group">
        <label class="rbv-label">Name</label>
        <input type="text" [(ngModel)]="selected.NAME" placeholder="Enter Name" class="form-control rounded-0"
               name="NAME" maxlength="251" autocomplete="off" (keydown.enter)="onConfirm()" autofocus="autofocus"/>
      </div>

    </div>
  </div>

  <div class="row" *ngIf="actionType == FileActionType.CHANGE_TYPE">
    <div class="col-sm-12">
      <label class="rbv-label">Document Type</label>
        <input-search placeholder="Select Type of Document"
                [regular]="true" [preset]="docTypes" [inputValue]="selected.DOCUMENT_TYPE"
                (valueChange)="docTypeChanged($event)">
              </input-search>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" (click)="onConfirm()">Confirm</button>
</div>
